import React, { useState, useEffect } from 'react';
import { getData, postData, putData, deleteData } from '../helpers/ApiSettings';

const Categories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editingCategory, setEditingCategory] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    description: ''
  });

  const fetchCategories = async () => {
    try {
      setLoading(true);
      const response = await getData('/categories?sort[0]=name:asc');
      setCategories(response.data.data);
      setError(null);
    } catch (err) {
      setError('Erreur lors du chargement des catégories');
      console.error('Error fetching categories:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingCategory) {
        await putData(`/categories/${editingCategory.documentId}`, { data: formData });
        alert('Catégorie modifiée avec succès');
      } else {
        await postData('/categories', { data: formData });
        alert('Catégorie créée avec succès');
      }
      
      // Close modal first
      const modal = document.getElementById('categoryModal');
      const bootstrapModal = window.bootstrap.Modal.getInstance(modal);
      bootstrapModal.hide();
      
      // Then reset form and fetch new data
      setFormData({ name: '', description: '' });
      setEditingCategory(null);
      await fetchCategories();
    } catch (err) {
      alert('Erreur lors de l\'enregistrement de la catégorie');
      console.error('Error saving category:', err);
    }
  };

  const handleEdit = (category) => {
    setEditingCategory(category);
    setFormData({
      name: category.name,
      description: category.description || ''
    });
    // Fixed Bootstrap modal reference
    const modal = new window.bootstrap.Modal(document.getElementById('categoryModal'));
    modal.show();
  };

  const handleDelete = async (id) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer cette catégorie ?')) {
      try {
        await deleteData(`/categories/${id}`);
        await fetchCategories();
        alert('Catégorie supprimée avec succès');
      } catch (err) {
        alert('Erreur lors de la suppression de la catégorie');
        console.error('Error deleting category:', err);
      }
    }
  };

  const handleAddNew = () => {
    setEditingCategory(null);
    setFormData({ name: '', description: '' });
    // Fixed Bootstrap modal reference
    const modal = new window.bootstrap.Modal(document.getElementById('categoryModal'));
    modal.show();
  };

  if (loading) {
    return (
      <div className="text-center p-5">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Chargement...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger" role="alert">
        {error}
      </div>
    );
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="h4 mb-0">Catégories</h2>
        <div>
          <button 
            onClick={fetchCategories} 
            className="btn btn-outline-primary me-2"
          >
            Actualiser
          </button>
          <button 
            onClick={handleAddNew}
            className="btn btn-primary"
          >
            Nouvelle Catégorie
          </button>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          {categories.length === 0 ? (
            <p className="text-center text-muted my-5">Aucune catégorie pour le moment</p>
          ) : (
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th>Nom</th>
                    <th>Description</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {categories.map((category) => (
                    <tr key={category.id}>
                      <td>{category.name}</td>
                      <td>{category.description || '-'}</td>
                      <td>
                        <div className="btn-group">
                          <button
                            className="btn btn-sm btn-primary me-2"
                            onClick={() => handleEdit(category)}
                          >
                            Modifier
                          </button>
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() => handleDelete(category.documentId)}
                          >
                            Supprimer
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* Modal for Add/Edit Category */}
      <div className="modal fade" id="categoryModal" tabIndex="-1">
        <div className="modal-dialog">
          <div className="modal-content">
            <form onSubmit={handleSubmit}>
              <div className="modal-header">
                <h5 className="modal-title">
                  {editingCategory ? 'Modifier la Catégorie' : 'Nouvelle Catégorie'}
                </h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label htmlFor="name" className="form-label">Nom</label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="description" className="form-label">Description</label>
                  <textarea
                    className="form-control"
                    id="description"
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                    rows="3"
                  ></textarea>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                  Annuler
                </button>
                <button type="submit" className="btn btn-primary">
                  {editingCategory ? 'Mettre à jour' : 'Créer'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Categories;